import './style/bolmateDialog.scss';

import {CloseButton, OrnamentShape, WithBackground} from '@dvrd/dvr-controls';

import React, {ReactNode} from 'react';

import {useTranslation} from 'react-i18next';

import BolmateButton from '../button/bolmateButton';

import classNames from 'classnames';

interface BolmateDialogProps {
    active: boolean;
    onClose: VoidFunction;
    title: string;
    children: ReactNode;
    onConfirm?: VoidFunction;
    confirmLabel?: ReactNode;
    cancelLabel?: ReactNode;
    confirmOrnaments?: OrnamentShape | OrnamentShape[];
    cancelOrnaments?: OrnamentShape | OrnamentShape[];
    confirmDisabled?: boolean;
    loading?: boolean;
    width?: string;
    className?: string;
    hideCancel?: boolean;
}

export default function BolmateDialog(props: BolmateDialogProps) {
    const {t} = useTranslation();
    const {
        active,
        onClose,
        title,
        children,
        onConfirm,
        confirmLabel = t('controls.dialog.confirm', 'Goedkeuren'),
        cancelLabel = t('controls.dialog.cancel', 'Annuleren'),
        confirmOrnaments,
        cancelOrnaments,
        confirmDisabled,
        loading,
        width = '36rem',
        className,
        hideCancel
    } = props;

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className={classNames('bolmate-dialog', 'default-popup', className)} style={{width}}>
                <div className='header-container'>
                    <h3>{title}</h3>
                    <CloseButton onClick={onClose} />
                </div>
                <div className='body-container'>{children}</div>
                {(!hideCancel || onConfirm) && (
                    <div className='footer-container'>
                        {!hideCancel && (
                            <BolmateButton
                                label={cancelLabel}
                                secondary
                                ornaments={cancelOrnaments}
                                onClick={onClose}
                                disabled={loading}
                            />
                        )}
                        {onConfirm && (
                            <BolmateButton
                                label={confirmLabel}
                                ornaments={confirmOrnaments}
                                onClick={onConfirm}
                                disabled={confirmDisabled || loading}
                            />
                        )}
                    </div>
                )}
            </div>
        </WithBackground>
    );
}
